export const toBorder = (hide: boolean): string => {
    return hide ? 'none' : '1px solid rgba(224, 224, 224, 1)';
}